import { useTranslation } from 'react-i18next';
import { YStack } from 'tamagui';

import { QrCodeSetupView } from './components/QrCodeSetupView';
import { LogoTimeDate } from '../../components/common/LogoTimeDate';
import { ThreeCardLayout } from '../../components/layouts/ThreeCardLayout';
import { UnlockButton } from '../Lock_Default/components/UnlockButton';

interface InitialLockScreenProps {
  onUnlock: () => void;
}

export const InitialLockScreen: React.FC<InitialLockScreenProps> = ({ onUnlock }) => {
  const { t } = useTranslation();

  return (
    <ThreeCardLayout
      left={<LogoTimeDate />}
      middleProps={{ alignItems: 'flex-end' }}
      middle={
        <YStack
          flex={1}
          flexDirection="column"
          justifyContent="flex-end"
          alignItems="stretch"
          gap="$12">
          <UnlockButton text={t('lock.tapToUnlock')} onUnlock={onUnlock} />
        </YStack>
      }
      right={<QrCodeSetupView />}
    />
  );
};
